import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import * as Ant from "antd";
import { Link } from "react-router-dom";
import { useGuardian, useRouter, useTranslate } from "@bluelibs/x-ui";
import { Routes } from "@bundles/UIAppBundle";
import { ApolloError, useLazyQuery } from "@apollo/client";
import { Form, Input, Button, Row, Col, Alert, notification, } from "antd";
import { FindCurrencies, } from "@bundles/UIAppBundle/queries/FindCurrencies";
export function Login() {
    const guardian = useGuardian();
    const [fetchCurrencies, { data, loading, error }] = useLazyQuery(FindCurrencies);
    const t = useTranslate();
    const tl = useTranslate("authentication.login");
    const router = useRouter();
    const [loginError, setLoginError] = useState(null);
    // const { register, handleSubmit, errors } = useForm<FormInput>();
    const onSubmit = (data) => {
        const { username, password } = data;
        guardian
            .login(username.trim(), password.trim())
            .then(() => {
            notification.success({
                message: tl("welcome"),
            });
            fetchCurrencies()
                .then((res) => {
                localStorage.setItem("currency-data", JSON.stringify(res.data.FindCurrencies));
            })
                .catch((err) => {
                if (err instanceof ApolloError) {
                    const errMessage = err.message.toLowerCase().split(" ").join("_");
                    const i18nMessage = t(`apiErrors.${errMessage}`);
                    Ant.notification.warn({
                        message: i18nMessage.length > 0 ? i18nMessage : t("generics.error"),
                    });
                }
                else {
                    Ant.notification.warn({
                        message: t("generics.error"),
                        description: t("generics.error_message"),
                    });
                }
            })
                .finally(() => {
                router.go(Routes.DASHBOARD);
            });
        })
            .catch((err) => {
            setLoginError(err);
        });
    };
    const style = { minHeight: "100vh" };
    return (_jsx(Row, Object.assign({ justify: "center", align: "middle", style: style, className: "login-page" }, { children: _jsx(Col, Object.assign({ span: 20, md: 12, lg: 8 }, { children: _jsxs(Form, Object.assign({ className: "authentication-form", onFinish: (data) => onSubmit(data), layout: "vertical", requiredMark: false }, { children: [_jsx("img", { src: "/public/wp-energy-logo-2.png", alt: "wpenergy-logo", className: "login-page-logo" }, void 0), _jsx(Form.Item, Object.assign({ name: "username", rules: [{ required: true }], className: "authentication-form-item", label: tl("fields.username") }, { children: _jsx(Input, { placeholder: tl("fields.username"), className: "authentication-form-input" }, void 0) }), void 0), _jsx(Form.Item, Object.assign({ name: "password", rules: [{ required: true }], className: "authentication-form-item", label: tl("fields.password") }, { children: _jsx(Input, { type: "password", placeholder: tl("fields.password"), className: "authentication-form-input" }, void 0) }), void 0), _jsx(Form.Item, { children: _jsx(Link, Object.assign({ className: "authentication-form-forgot", to: router.path(Routes.FORGOT_PASSWORD) }, { children: tl("forgotPassword_btn") }), void 0) }, void 0), _jsx(Form.Item, Object.assign({ className: "authentication-form-item" }, { children: _jsx(Button, Object.assign({ htmlType: "submit", className: "authentication-form-button", size: "large" }, { children: tl("login") }), void 0) }), void 0), loginError && (_jsx(Alert, { message: loginError.networkError
                            ? loginError.toString()
                            : tl("invalid_credentials"), type: "error" }, void 0))] }), void 0) }), void 0) }), void 0));
}
